import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { CoordinatesModel } from 'src/app/models/company.model';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
  @ViewChild('mapContainer', { static: false }) mapContainer: ElementRef;
  map: google.maps.Map;
  @Output() selecting: EventEmitter<CoordinatesModel> = new EventEmitter();

  // Coordinates array 14.6014208,-90.5347072
  @Input() coordinates: { lat: number, lng: number }[] = [];
  @Input() allowSelect = false;
  currentMarker: google.maps.Marker | null = null;

  ngOnInit() { }

  ngAfterViewInit() {
    this.initMap();
  }

  initMap() {
    const mapOptions: google.maps.MapOptions = {
      center: new google.maps.LatLng(this.coordinates[0].lat, this.coordinates[0].lng),
      zoom: 9
    };

    this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);
    //todo
    this.coordinates.forEach(coord => {
      this.currentMarker = new google.maps.Marker({
        position: coord,
        map: this.map
      });
    });

    if (this.allowSelect) {
      this.map.addListener('click', (event: google.maps.MapMouseEvent) => {
        this.handleMapClick(event);
      });
    }
  }

  handleMapClick(event: google.maps.MapMouseEvent) {
    const clickedLocation = event.latLng;
    if (clickedLocation) {
      var selected = new CoordinatesModel();
      selected.lat = clickedLocation.lat();
      selected.lng = clickedLocation.lng();
      // Remove the previous marker if it exists
      if (this.currentMarker) {
        this.currentMarker.setMap(null); // Detach the marker from the map
      }

      // Add a new marker at the clicked location
      this.currentMarker = new (google.maps as any).Marker({
        position: clickedLocation,
        map: this.map
      });

      this.selecting.emit(selected);
    }
  }
}